import { render } from "./AddAttendeeComponent.vue?vue&type=template&id=6d15203c"
import script from "./AddAttendeeComponent.vue?vue&type=script&lang=js"
export * from "./AddAttendeeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__